import "./App.css";
import { OS } from "./components";

function App() {
  return <OS />;
}

export default App;
